import React from "react";
import styled, { css } from "styled-components";
import * as Accordion from "@radix-ui/react-accordion";
import AccordionWrapper from "../Accordion";
import Sinks from "./Components/Sinks";
import Holes from "./Components/Holes";
import Accessories from "./Components/Accessories";
import Edges from "./Components/Edges";
import Selected from "./Components/Selected";
import { useGetBuilderDataQuery } from "../../lib/redux/api/builder-api";
import { transparentize } from "polished";
import { useSearchParams } from "react-router-dom";
import AddToCart from "../Cart/AddToCart";
import { useSelector } from "react-redux";
import { useUpdateCart } from "../../hooks/use-update-cart";
import { getSelectedTexture } from "../../lib/redux/slices/dimensions-slice";

const Sidebar = ({ stage, canvasOffsetX, isLoading }) => {
  const cartData = useSelector((s) => s.cart);

  const { data } = cartData;

  const [params] = useSearchParams();

  const category = params.get("cat");
  const catId = params.get("id");
  const { data: builderData = [] } = useGetBuilderDataQuery({
    category,
    catId,
  });
  const { updateCart } = useUpdateCart();

  const texture = useSelector(getSelectedTexture);


  const accordianItemKey = [
    "selected",
    "kantprofiler",
    "disklador",
    "tillbehor",
    "halurtag",
  ];

  React.useEffect(() => {
    if (
      data &&
      Object.entries(data).length &&
      document.getElementsByClassName("dynamic-price-from-builder").length
    ) {
      document.querySelector(".dynamic-price-from-builder").innerHTML =
        data?.totalAmount?.formatted_price;
    }
  }, [data]);

  React.useEffect(() => {
    if (!isLoading) {
      updateCart((s) => s);
    }
  }, [isLoading]);

  return (
    <Aside>
      <div className="sidebar-attribute">
        {Object.entries(builderData).length ? (
          <AccordionWrapper>
            <Accordion.Root className="AccordionRoot" type="single" collapsible>
              {accordianItemKey.map((key) => {
                const data = builderData[key];
                return (
                  <Accordion.Item
                    className="AccordionItem"
                    value={key}
                    key={key}
                  >
                    <Accordion.Header className="AccordionTrigger" asChild>
                      <Accordion.Trigger>{key === "selected" ? (texture.name || data.label): data.label}</Accordion.Trigger>
                    </Accordion.Header>
                    <Accordion.Content className="AccordionContent">
                      <div className="AccordionContentInner">
                        {key === "selected" && (
                          <Selected
                            data={data}
                            stage={stage}
                            canvasOffsetX={canvasOffsetX}
                          />
                        )}
                        {key === "kantprofiler" && <Edges data={data} />}
                        {key === "disklador" && (
                          <Sinks
                            data={data}
                            stage={stage}
                            montering={builderData["montering"]}
                          />
                        )}
                        {key === "halurtag" && (
                          <Holes data={data} stage={stage} />
                        )}
                        {key === "tillbehor" && <Accessories data={data} />}
                      </div>
                    </Accordion.Content>
                  </Accordion.Item>
                );
              })}
            </Accordion.Root>
          </AccordionWrapper>
        ) : null}
      </div>
      <AddToCart stage={stage} />
    </Aside>
  );
};
export default Sidebar;

const Aside = styled.aside`
  ${({ theme }) =>
    css`
      height: 100%;
      background: ${theme.colors.gray["500"]};
      display: flex;
      flex-direction: column;

      @media (min-width: 992px) {
        position: sticky;
        top: 0;
      }

      .sidebar-attribute {
        overflow: hidden auto;
        height: 100%;
        z-index: 1;

        &::-webkit-scrollbar {
          width: 5px;

          /* Track */
          &-track {
            box-shadow: inset 0 0 5px ${theme.colors.gray["500"]};
            border-radius: 10px;
          }

          /* Handle */
          &-thumb {
            background: ${theme.colors.primary};
            border-radius: 10px;
            height: 5px;

            &:hover {
              background: ${transparentize(0.2, theme.colors.primary)};
            }
          }
        }
      }
    `}
`;
